/* ONTVEY theme enhancements — small, dependency-free. */
(function () {
  'use strict';

  var RV_KEY = 'ontvey:recently-viewed';

  function readRV() {
    try {
      return JSON.parse(localStorage.getItem(RV_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  /* Record the current product (called from theme.liquid on product pages). */
  window.ontveyRecordView = function (handle) {
    if (!handle) return;
    try {
      var list = readRV().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  };

  /* ---------- Recently viewed ---------- */
  if (!customElements.get('ontvey-recently-viewed')) {
    customElements.define('ontvey-recently-viewed', class extends HTMLElement {
      connectedCallback() {
        var current = this.dataset.current;
        var limit = parseInt(this.dataset.limit || '4', 10);
        var handles = readRV().filter(function (h) { return h && h !== current; }).slice(0, limit);
        if (!handles.length) return;
        var list = this.querySelector('[data-rv-list]');
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var self = this;
        Promise.all(handles.map(function (h) {
          return fetch(root + 'products/' + encodeURIComponent(h) + '?view=ontvey-card')
            .then(function (r) { return r.ok ? r.text() : ''; })
            .catch(function () { return ''; });
        })).then(function (items) {
          var html = items.filter(function (t) { return t.indexOf('grid__item') > -1; }).join('');
          if (!html) return;
          list.innerHTML = html;
          self.hidden = false;
        });
      }
    });
  }

  /* ---------- Mobile sticky add to cart ---------- */
  if (!customElements.get('ontvey-sticky-atc')) {
    customElements.define('ontvey-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        var sectionId = this.dataset.section;
        this.mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
        if (!this.mainButton) return;
        this.priceTarget = this.querySelector('[data-sticky-price]');
        this.button = this.querySelector('[data-sticky-button]');
        this.priceSource = document.getElementById('price-' + sectionId);
        this.hidden = false;

        var self = this;
        this.button.addEventListener('click', function () {
          if (self.mainButton.disabled) return;
          self.mainButton.click();
        });

        var io = new IntersectionObserver(function (entries) {
          var e = entries[0];
          var below = e.boundingClientRect.top > window.innerHeight;
          self.classList.toggle('is-visible', !e.isIntersecting && !below);
        }, { threshold: 0 });
        io.observe(this.mainButton);

        var sync = function () {
          self.button.disabled = self.mainButton.disabled;
          var label = self.mainButton.querySelector('span');
          if (label) self.button.textContent = label.textContent.trim();
          if (self.priceSource && self.priceTarget) {
            var sale = self.priceSource.querySelector('.price__sale .price-item--sale, .price-item--last');
            var reg = self.priceSource.querySelector('.price__regular .price-item--regular');
            var src = self.priceSource.querySelector('.price--on-sale') ? sale : reg;
            if (src) self.priceTarget.textContent = src.textContent.trim();
          }
        };
        new MutationObserver(sync).observe(this.mainButton, { attributes: true, childList: true, subtree: true });
        if (this.priceSource) {
          new MutationObserver(sync).observe(this.priceSource, { childList: true, subtree: true, characterData: true });
        }
        document.body.classList.add('has-ontvey-sticky-atc');
      }
    });
  }

  /* ---------- Cart drawer recommendations ---------- */
  if (!customElements.get('ontvey-cart-recs')) {
    customElements.define('ontvey-cart-recs', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var exclude = (this.dataset.exclude || '').split(',');
        fetch(this.dataset.url)
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var listEl = doc.querySelector('.ontvey-cart-recs__list');
            if (!listEl) return;
            var kept = 0;
            listEl.querySelectorAll('li').forEach(function (li) {
              if (exclude.indexOf(li.dataset.productId) > -1 || kept >= 3) li.remove();
              else kept++;
            });
            if (!kept) return;
            self.querySelector('[data-recs-body]').appendChild(listEl);
            self.hidden = false;
            self.bindAdd();
          })
          .catch(function () {});
      }

      bindAdd() {
        this.querySelectorAll('button[data-variant-id]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var drawer = document.querySelector('cart-drawer');
            btn.disabled = true;
            btn.textContent = '…';
            var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
            fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
                sections: 'cart-drawer,cart-icon-bubble',
                sections_url: window.location.pathname
              })
            })
              .then(function (r) { return r.json(); })
              .then(function (state) {
                if (state.status) { btn.textContent = 'Add'; btn.disabled = false; return; }
                if (drawer && drawer.renderContents) drawer.renderContents(state);
              })
              .catch(function () { btn.textContent = 'Add'; btn.disabled = false; });
          });
        });
      }
    });
  }
})();
